import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { merge } from 'lodash';
import { defaultUser } from '@utils/recordHelpers';

import { PolarisFormProvider } from '@container';
import omit from 'lodash/omit';

import { ViewMajorMonotone } from '@shopify/polaris-icons';

import { UserForm } from '@presentational';

import axiosRails from '@utils/axios';

const propTypes = {
  user: PropTypes.object.isRequired,
  seller: PropTypes.object.isRequired,
  location: PropTypes.array.isRequired, 
  update: PropTypes.bool,
  isSeller: PropTypes.bool,
  submitURL: PropTypes.string.isRequired,

  sellerApplicationFormURL: PropTypes.string,
};

const defaultProps = {
  update: false,
}

class UserFormWrapper extends Component {
  constructor(props) {
    super(props);
    let userData = {...props.user, seller: props.seller};
    
    this.state= {
      //...defaultValues // When using polaris instead of formik
      defaultValues: props.update ? userData : merge(userData, defaultUser),
      method: props.update ? "PATCH" : "POST",
      isSeller: props.isSeller,
    }
  }

  render() {
    let { defaultValues, method, isSeller } = this.state;
    let { submitURL, seller, location, deleteURL, sellerApplicationFormURL } = this.props;
    if(!defaultValues.seller.default_location_id){
      defaultValues.seller.default_location_id = location.length ? location[0].id : "";
    }

    let pageSecondaryActions = [];
    if( sellerApplicationFormURL ){
      pageSecondaryActions = [ ...pageSecondaryActions, { icon: ViewMajorMonotone, content: "Ver Aplicación", url: sellerApplicationFormURL, external: true } ]
    }

    return (
      <PolarisFormProvider
        title={ I18n.t("activerecord.models.user.one") }
        defaultValues={ defaultValues }
        handleSubmit={ this.customHandleSubmit }
        pageProps={{
          breadcrumbs: [{content: I18n.t("actions.back"), url: '/admin/users'}],
          secondaryActions: pageSecondaryActions,
          subtitle: (!!this.props.seller && this.props.seller.bright_pearl_supplier_id) ? `ID BP: ${this.props.seller.bright_pearl_supplier_id}` : null
        }}
      >
      { (renderProps) =>
        <div>
          <UserForm
            toggleSeller={this.toggleSeller}
            isSeller={ isSeller }
            location={ location }
            deleteURL={ deleteURL }
            deliveryTeamOptions={ this.props.deliveryTeamOptions }
            {...renderProps} />
        </div>
      }
      </PolarisFormProvider>
    );
  }

  toggleSeller = () => {
    this.setState({ isSeller: !this.state.isSeller });
  }

  customHandleSubmit = async (values, formikBag) => {
    const { setStatus, setErrors } = formikBag;
    const { method, isSeller } = this.state;
    const { submitURL } = this.props;

    setStatus({ submitLoading: true  });

    let submitValues = {
      ...omit(values, ['seller']),
      seller_attributes: {
        id: values.seller && values.seller.id,
        _destroy: !isSeller // mark for destruction if isSeller isn't set. If seller doesn't exists then this will do nothing
      }
    }

    if(isSeller){
      submitValues = {
        ...submitValues,
        seller_attributes: values.seller,
      }
    }

    submitValues = { user: submitValues }; // Nest into user

    const response = await axiosRails({
      method: method,
      url: submitURL,
      data: submitValues
    });

    const data = response.data;
    if(data.success){
      setStatus({
        submitLoading: false,
        showToast: true,
        toastContent: I18n.t("app.messages.save_success")
      });
      window.location = data.redirectURL;
      return true
    }
    else {
      setStatus({
        submitLoading: false,
        showToast: true,
        toastContent: I18n.t("app.messages.record_errors")
      })
      setErrors(data.errors);
      console.log("E", data.errors)
    }

  }
}


UserFormWrapper.propTypes = propTypes;
UserFormWrapper.defaultProps = defaultProps;


export default UserFormWrapper;
